module.exports = __webpack_public_path__ + "static/media/prismport-1.237ac90b.jpg";